import * as React from 'react'

import { TIMEFRAME, TIMEFRAME_FAVORITE_DEFAULTS, TIMEFRAME_FAVORITE_DEFAULTS_FREE } from '../../constants/common'
import { useSyncLocalStorage } from '../../website-shared'

type FavoriteTimeframesMap = { [K in TIMEFRAME | 'intraday']?: boolean }

const LOCAL_STORAGE_KEY = 'favoriteTimeframesMap'

export function useFavoriteTimeframes(isPremium = true) {
  const { state, setState } = useSyncLocalStorage<FavoriteTimeframesMap>(
    LOCAL_STORAGE_KEY,
    isPremium ? TIMEFRAME_FAVORITE_DEFAULTS : TIMEFRAME_FAVORITE_DEFAULTS_FREE
  )

  const toggleFavoriteTimeframe = React.useCallback(
    (timeframe: TIMEFRAME) => {
      setState((prevState) => ({
        ...prevState,
        [timeframe]: !prevState[timeframe],
      }))
    },
    [setState]
  )

  const favoriteTimeframes = React.useMemo(
    () => Object.keys(state).filter((key) => state[key as keyof FavoriteTimeframesMap]),
    [state]
  )

  return { favoriteTimeframes, toggleFavoriteTimeframe }
}
